export default {
  name: "FilterConfigDialog",
  props: ["filter"],
  data: () => ({
    dialog: false,
    filterName: "",
    saveFor: "user"
  }),
  methods: {
    saveFilterConfig() {
      if (this.filterName && this.user?._id) {
        const filterToSave = {
          query: this.filter,
          name: this.filterName,
          user: this.user._id,
          saveFor: this.saveFor,
          principal: this.currentPrincipal._id
        };
        this.$emit("saveFilter", filterToSave);
      }
      this.dialog = false;
    }
  },
  computed: {
    isAdmin() {
      return this.user?.scopes?.includes("role:admin");
    },
    isEventAdmin() {
      return (
        this.isAdmin || this.currentUser?.scopes?.includes("role:events_admin")
      );
    },
    filterLength() {
      const operator = Object.keys(this.filter)?.[0];
      return this.filter[operator]?.length ?? 0;
    },
    user() {
      return this.$store.state.currentUser;
    },
    currentPrincipal() {
      return this.$store.state.selectedPrincipal;
    }
  }
};
